// /admin/forgot-password — pide email y dispara reset email vía backend.
// Mensaje de éxito neutro (no revela si el email existe).

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';

import Logo from '../components/Logo';
import { useAuth } from '../context/AuthContext';

const RX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgotPassword() {
  const { t } = useTranslation();
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [errorCampo, setErrorCampo] = useState(null);
  const [enviado, setEnviado] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErrorCampo(null);
    if (!RX_EMAIL.test(email.trim())) {
      setErrorCampo(t('auth.errores.email_invalido'));
      return;
    }
    setEnviando(true);
    try {
      await requestPasswordReset(email.trim());
      setEnviado(true);
    } catch (_) {
      setEnviado(true);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <Link to="/" className="login-logo"><Logo /></Link>
        <h1 className="login-titulo">{t('admin.forgot.title')}</h1>
        <p className="login-sub">{t('admin.forgot.sub')}</p>

        {!enviado ? (
          <form className="login-form" onSubmit={submit} noValidate>
            <div className="modal-campo">
              <label htmlFor="forgot-email">{t('admin.forgot.email_label')}</label>
              <input
                id="forgot-email"
                type="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('auth.email_placeholder')}
                disabled={enviando}
              />
              {errorCampo && (
                <div className="modal-error-campo">
                  <AlertCircle size={14} strokeWidth={1.75} />
                  <span>{errorCampo}</span>
                </div>
              )}
            </div>

            <button type="submit" className="btn-primary login-btn" disabled={enviando}>
              {enviando ? (
                <><Loader2 size={16} className="spin" strokeWidth={1.5} /> {t('auth.enviando')}</>
              ) : (
                t('admin.forgot.submit')
              )}
            </button>
          </form>
        ) : (
          <div className="login-success">
            <CheckCircle2 size={32} strokeWidth={1.5} />
            <p>{t('admin.forgot.success')}</p>
          </div>
        )}

        <p className="login-volver">
          <Link to="/login">{t('admin.forgot.back_to_login')}</Link>
        </p>
      </div>
    </div>
  );
}
